import React, { useRef } from 'react';
import { X } from 'lucide-react';

const Tab = ({
  tab,
  isSelected,
  isEditing,
  editingTabName,
  setEditingTabName,
  onTabClick,
  onTabDoubleClick,
  onTabNameSave,
  onTabNameKeyDown,
  onDeleteTab,
  isHovered,
  onMouseEnter,
  onMouseLeave
}) => {
  const editTabInputRef = useRef(null);

  return (
    <div
      className="relative"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {isEditing ? (
        <input
          ref={editTabInputRef}
          type="text"
          value={editingTabName}
          onChange={(e) => setEditingTabName(e.target.value)}
          onKeyDown={onTabNameKeyDown}
          onBlur={onTabNameSave}
          className="py-1.5 px-3 text-sm font-medium border border-secondaryDark rounded focus:outline-none focus:ring-2 focus:ring-secondaryDark/20 min-w-[100px]"
        />
      ) : (
        <button
          onClick={() => onTabClick(tab.tab_id)}
          onDoubleClick={() => onTabDoubleClick(tab)}
          className={`py-2 px-2 text-sm font-medium border-b-2 transition-colors ${
            isSelected
              ? 'border-secondaryDark text-secondaryDark'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
          }`}
        >
          {tab.tab_name}
        </button>
      )}
      
      {isHovered && !isEditing && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDeleteTab(tab.tab_id);
          }}
          className="absolute top-1 right-0 -mr-1.5 text-red-400 rounded-full p-px hover:text-red-500 transition-colors"
          title="Delete tab"
        >
          <X size={12} />
        </button>
      )}
    </div>
  );
};

export default Tab;